module.exports = __webpack_public_path__ + "img/payment-ticket.40b3304d.svg";